import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex w-full" }
const _hoisted_2 = { class: "md:px-14 mt-8 flex flex-col justify-start w-full" }
const _hoisted_3 = { class: "col-span-12" }
const _hoisted_4 = { class: "flex justify-between items-center" }
const _hoisted_5 = { class: "col-span-10" }
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = { class: "col-span-4" }
const _hoisted_8 = { class: "mb-2" }
const _hoisted_9 = { class: "col-span-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, "Lattes", -1)
const _hoisted_11 = { class: "col-span-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, "Linkedin", -1)
const _hoisted_13 = { class: "col-span-12" }
const _hoisted_14 = { class: "mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Editor = _resolveComponent("Editor")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
        onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.disabled = false)),
        class: "grid grid-cols-12 gap-5 bg-white p-5 md:p-8 rounded-md shadow-md"
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h6", null, _toDisplayString(_ctx.$t("labels.generic", {
                  pt: "Títulos e premiações",
                  en: "Titles and awards",
                })), 1),
            _createVNode(_component_Button, {
              type: "submit",
              label: "Salvar",
              class: "btn-primary p-button-sm",
              loading: _ctx.loading,
              disabled: _ctx.disabled || _ctx.validation()
            }, null, 8, ["loading", "disabled"])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Título",
                en: "Title",
              })), 1),
          _createVNode(_component_InputText, {
            id: "title",
            type: "text",
            modelValue: _ctx.user.title,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.title) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Site pessoal",
                en: "Personal site",
              })), 1),
          _createVNode(_component_InputText, {
            id: "generalUrl",
            type: "text",
            modelValue: _ctx.user.generalUrl,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.generalUrl) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(_component_InputText, {
            id: "lattesUrl",
            type: "text",
            modelValue: _ctx.user.lattesUrl,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.lattesUrl) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(_component_InputText, {
            id: "linkedinUrl",
            type: "text",
            modelValue: _ctx.user.linkedinUrl,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user.linkedinUrl) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Biografia ",
                en: "Biography",
              })), 1),
          _createVNode(_component_Editor, {
            id: "description",
            modelValue: _ctx.user.description,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.user.description) = $event)),
            editorStyle: "height: 320px",
            onTextChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.disabled = false))
          }, null, 8, ["modelValue"]),
          _createElementVNode("small", {
            class: _normalizeClass(`${
              _ctx.user.description?.length > 5000 ? 'text-h-error-400' : 'invisible'
            }`)
          }, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Tamanho foi exedido",
                en: "Size has been exceeded",
              })), 3)
        ])
      ], 32)
    ])
  ]))
}